"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MartianRails = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
class MartianRails extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.MARTIAN_RAILS,
            tags: [Tags_1.Tags.BUILDING],
            cost: 13,
            metadata: {
                cardNumber: '007',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 1 Energy to gain 1 M€ for each City tile ON MARS.', (eb) => {
                        eb.energy(1).startAction.megacredits(1).slash();
                        eb.city(Size_1.Size.SMALL).any.asterix();
                    }).br;
                }),
            },
        });
    }
    play(_player) {
        return undefined;
    }
    canAct(player) {
        return player.energy >= 1;
    }
    action(player) {
        player.deductResource(Resources_1.Resources.ENERGY, 1);
        player.addResource(Resources_1.Resources.MEGACREDITS, player.game.getCitiesInPlayOnMars(), { log: true });
        return undefined;
    }
}
exports.MartianRails = MartianRails;
//# sourceMappingURL=MartianRails.js.map